var map = {
	"./Logo-ikon.blå.png": "2385",
	"./Logo-ikon.hvid.png": "70ea",
	"./Logo-ikon.sort.png": "aed0",
	"./LogoNO-full.sorthvid-1.png": "1d49",
	"./LogoNO-full.sorthvid-2.png": "b3f3",
	"./LogoNO-type.hvid.png": "9653",
	"./LogoNO-type.sort.png": "04b9",
	"./fb-post/icons-2.png": "b6e1",
	"./fb-post/icons-3.png": "b50b",
	"./fb-post/icons-list-1.png": "ade5",
	"./fb-post/icons-list-2.png": "3572",
	"./fb-post/icons-list-3.png": "338e",
	"./fb-post/icons-list-4.png": "63d2",
	"./fb-post/icons-list-5.png": "144c",
	"./fb-post/icons-list-6.png": "cd48",
	"./fb-post/icons.png": "36c0",
	"./parties/A.png": "85d0",
	"./parties/FrP.png": "2531",
	"./parties/H.png": "3b2c",
	"./parties/KrF.png": "7e29",
	"./parties/MDG.png": "ceda",
	"./parties/R.png": "17bf",
	"./parties/SP.png": "0f24",
	"./parties/SV.png": "74d2",
	"./parties/Sentrum.png": "1d72",
	"./parties/V.png": "e00c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";